export interface YouTubeVideo {
  id: string;
  videoId: string;
  title: string;
  description: string;
  category: 'tips' | 'vlogs' | 'reviews' | 'events' | 'attractions';
  featured: boolean;
  publishedAt: string;
}

// Tomorrow33 YouTube Channel ID - UPDATE THIS with your actual channel ID
// Find your channel ID at: https://www.youtube.com/account_advanced
// Or use a tool like: https://commentpicker.com/youtube-channel-id.php
export const YOUTUBE_CHANNEL_ID = 'UCFdpKMcaLCfu48Upyib3J0Q';
export const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@EnchantedNews';
export const YOUTUBE_CHANNEL_NAME = 'Enchanted News';

// Featured videos - these will be replaced with real videos once uploaded to the channel
export const youtubeVideos: YouTubeVideo[] = [
  {
    id: '1',
    videoId: 'HnBfyqHMEE8', // Disney World travel planning video
    title: 'Ultimate Disney World Tips for First-Timers',
    description: 'Everything you need to know for your first Disney World visit. From park reservations to planning strategies.',
    category: 'tips',
    featured: true,
    publishedAt: '2024-12-01',
  },
  {
    id: '2',
    videoId: '9VfFX9pS8YQ', // Magic Kingdom walkthrough
    title: 'Magic Kingdom Complete Walkthrough',
    description: 'A full day at Magic Kingdom covering every land and must-do attractions.',
    category: 'vlogs',
    featured: true,
    publishedAt: '2024-11-15',
  },
  {
    id: '3',
    videoId: 'djV11Xbc914', // Disney dining experience
    title: 'Best Disney World Restaurants Ranked',
    description: 'Our honest reviews of the top dining experiences at Walt Disney World.',
    category: 'reviews',
    featured: false,
    publishedAt: '2024-11-01',
  },
  {
    id: '4',
    videoId: 'GCmRj7DxHdE', // EPCOT festival coverage
    title: 'EPCOT Festival of the Arts 2025',
    description: 'Complete coverage of the Festival of the Arts including food, art, and entertainment.',
    category: 'events',
    featured: false,
    publishedAt: '2024-10-20',
  },
  {
    id: '5',
    videoId: 'wMPF7NxqQ2M', // Top attractions video
    title: 'Top 10 Disney World Attractions',
    description: 'Our ranking of the absolute must-do rides and attractions at Walt Disney World.',
    category: 'attractions',
    featured: true,
    publishedAt: '2024-10-10',
  },
  {
    id: '6',
    videoId: 'TXbHShUnwxY', // Budget tips video
    title: 'Disney World on a Budget',
    description: 'Money-saving tips and tricks to make your Disney vacation more affordable.',
    category: 'tips',
    featured: false,
    publishedAt: '2024-09-25',
  },
];

export const getFeaturedVideos = () => youtubeVideos.filter(v => v.featured);
export const getVideosByCategory = (category: YouTubeVideo['category']) => 
  youtubeVideos.filter(v => v.category === category);
